import React from 'react';
import { FileText, Check, AlertCircle, Lock } from 'lucide-react';
interface Document {
  name: string;
  status: 'verified' | 'pending' | 'missing';
  date?: string;
}
interface DocumentSectionProps {
  documents: Document[];
}
export function DocumentSection({
  documents
}: DocumentSectionProps) {
  return <div data-testid="document-section" className="border border-gray-300 bg-white p-6" data-id="element-215">
      <h3 data-testid="document-section-title" className="text-xl font-bold text-[#1f2933] mb-6 border-b border-gray-200 pb-2" data-id="element-216">
        Legal Documentation
      </h3>
      <div data-testid="document-section-list" className="space-y-4" data-id="element-217">
        {documents.map((doc, index) => <div key={index} data-testid={`document-item-${index + 1}`} data-status={doc.status} className="flex items-center justify-between p-4 border border-dashed border-gray-300 bg-gray-50" data-id="element-218">
            <div className="flex items-center gap-4" data-id="element-219">
              <div className="w-10 h-10 bg-gray-200 flex items-center justify-center rounded-sm" data-id="element-220">
                <FileText className="w-5 h-5 text-gray-500" data-id="element-221" />
              </div>
              <div data-id="element-222">
                <p data-testid={`document-item-${index + 1}-name`} className="font-medium text-[#1f2933]" data-id="element-223">
                  {doc.name}
                </p>
                {doc.date && <p data-testid={`document-item-${index + 1}-date`} className="text-xs text-gray-500 font-mono mt-1" data-id="element-224">
                    Uploaded: {doc.date}
                  </p>}
              </div>
            </div>

            <div className="flex items-center gap-2" data-id="element-225">
              {doc.status === 'verified' && <span data-testid={`document-item-${index + 1}-status`} className="flex items-center gap-1 text-xs font-mono text-green-700 bg-green-50 px-2 py-1 border border-green-200 rounded" data-id="element-226">
                  <Check className="w-3 h-3" data-id="element-227" /> VERIFIED
                </span>}
              {doc.status === 'pending' && <span data-testid={`document-item-${index + 1}-status`} className="flex items-center gap-1 text-xs font-mono text-yellow-700 bg-yellow-50 px-2 py-1 border border-yellow-200 rounded" data-id="element-228">
                  <Lock className="w-3 h-3" data-id="element-229" /> PENDING REVIEW
                </span>}
              {doc.status === 'missing' && <span data-testid={`document-item-${index + 1}-status`} className="flex items-center gap-1 text-xs font-mono text-red-700 bg-red-50 px-2 py-1 border border-red-200 rounded" data-id="element-230">
                  <AlertCircle className="w-3 h-3" data-id="element-231" /> MISSING
                </span>}
            </div>
          </div>)}
      </div>
      <div data-testid="document-section-verification-note" className="mt-6 p-4 bg-blue-50 border border-blue-100 text-sm text-blue-800" data-id="element-232">
        <p className="font-bold mb-1" data-id="element-233">Citiplots Verification Promise</p>
        <p data-id="element-234">
          All documents marked "Verified" have been cross-referenced with local
          municipal records.
        </p>
      </div>
    </div>;
}